// container imports
import { APP_BODY_CONTAINER } from "./body.container.js";
import { APP_LAYOUT_CONTAINER } from "./layout.container.js";
import { APP_COLUMN_CONTAINER } from "./column.container.js";
import { APP_CONTAINER } from "./container.js";
// Tab, Md & Popup container's default are within widgets itself
import { APP_TAB } from "./tab.js";
import { APP_MASTER_DETAIL } from "./masterdetail.js";
import { APP_POPUP } from "./popup.js";
import { APP_PROGRESSBAR } from "./progressbar.js";
import { APP_HYPERLINK } from "./hyperlink.js";
import { APP_LABEL } from "./label.js";
import { APP_KANBAN } from "./kanban.js";
import { APP_MATRIX } from "./matrix.js";
import { APP_IMAGE } from "./image.js";
import { APP_IFRAME } from "./iframe.js";
import { APP_GALLERY } from "./gallery.js";
import { APP_CARD } from "./card.js";
import { APP_ICON } from "./icon.js";
import { APP_BUTTON } from "./button.js";
import { APP_CUSTOM_COMPONENT } from "./custom.js";
import { SHEET } from "./sheet.js";
import { APP_RICHTEXT } from "./richtext.js";
import { APP_VIEWS } from "./view.js";
import { APP_TIMELINE } from "./timeline.js";
import { DECISION_TABLE } from "./decision.table.js";
import { APP_DIVIDER } from "./divider.js";

export const APP_THEME_MODEL = {
  ...APP_BODY_CONTAINER,
  ...APP_CONTAINER,
  ...APP_LAYOUT_CONTAINER,
  ...APP_COLUMN_CONTAINER,
  ...APP_IFRAME,
  ...APP_TAB,
  ...APP_PROGRESSBAR,
  ...APP_HYPERLINK,
  ...APP_LABEL,
  ...APP_KANBAN,
  ...APP_MATRIX,
  ...APP_IMAGE,
  ...APP_MASTER_DETAIL,
  ...APP_POPUP,
  ...APP_GALLERY,
  ...APP_CARD,
  ...APP_ICON,
  ...APP_BUTTON,
  ...APP_CUSTOM_COMPONENT,
  ...SHEET,
  ...APP_RICHTEXT,
  ...APP_VIEWS,
  ...APP_TIMELINE,
  ...DECISION_TABLE,
  ...APP_DIVIDER
};
